export default __webpack_public_path__ + "static/media/3.fc00bcd9.PNG";